import { createSlice } from '@reduxjs/toolkit'

const initialState = { filter: null, acountry: null }

export const FilterSlice = createSlice({
    name: 'filterSlice',
    initialState: initialState,
    reducers: {
        addFilter: (state, action) => {
            state.filter = action.payload
            return state
        },
        addCountry: (state, action) => {
            state.acountry = action.payload
            return state
        }
    },
    extraReducers: (builder) => {
        builder.addCase('LOGOUT', () => initialState)
    }
})

export const { addFilter, addCountry } = FilterSlice.actions
export default FilterSlice.reducer